import { memo } from 'react';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import PropTypes from 'prop-types';

const _LeadersCard = ({ leader }) => {
	return (
		<div className="leaders__items-element">
			<GatsbyImage
				alt={leader.imageAlt}
				image={getImage(leader.image)}
				className="leaders__items-element-img"
			/>
			<h3 className="leaders__items-element-title typography typography--h3 typography--black">
				{leader.title}
			</h3>
			<h4 className="leaders__items-element-subtitle typography typography--h6 typography--black">
				{leader.subtitle}
			</h4>
			<div
				className="leaders__items-element-body typography typography--body typography--black"
				dangerouslySetInnerHTML={{
					__html: leader.body,
				}}
			/>
		</div>
	);
};

_LeadersCard.propTypes = {
	leader: PropTypes.shape({
		image: PropTypes.object.isRequired,
		imageAlt: PropTypes.string,
		title: PropTypes.string.isRequired,
		subtitle: PropTypes.string.isRequired,
		body: PropTypes.string.isRequired,
	}).isRequired,
};

_LeadersCard.defaultProps = {
	leader: {
		imageAlt: '',
	},
};

const LeadersCard = memo(_LeadersCard);

export default LeadersCard;
